import React from 'react';
import './Neighborhood.css';

const Neighborhood = () => (
    <div className="property-detail-neighborhood">
        <section className="section section-neighborhood">
            <div className="container">
                <div className="columns">
                    <div className="column is-10-tablet is-offset-1-tablet">
                        <h3 className="big-title border-left-yellow">
                            GET TO KNOW YOUR<br />
                            NEIGHBORHOOD
                        </h3>
                    </div>
                </div>
            </div>
        </section>
    </div>
);

export default Neighborhood;
